import { render, staticRenderFns } from "./samsung.vue?vue&type=template&id=55cd138c&scoped=true&lang=pug"
import script from "./samsung.vue?vue&type=script&lang=js"
export * from "./samsung.vue?vue&type=script&lang=js"
import style0 from "./samsung.vue?vue&type=style&index=0&id=55cd138c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cd138c",
  null
  
)

export default component.exports